import { IntegerWidget } from 'angular2-schema-form';
import { Component } from '@angular/core';

@Component({
  selector: 'app-sf-integer-widget',
  templateUrl: './integer.widget.html'
})
export class MyIntegerWidgetComponent extends IntegerWidget { }



// WEBPACK FOOTER //
// ./src/shared/form-widgets/integer/integer.widget.ts